import { Navigate } from "react-router-dom";

import { detectLocale } from "@/i18n/detect-locale";

export function RootRedirect(): JSX.Element {
  const locale = detectLocale();
  return <Navigate replace to={`/${locale}`} />;
}
